<template>
  <div class="w-100 list-group mb-3  bg-white">
    <div class="py-3 mx-2 d-flex align-content-center justify-content-between border-bottom">
      <div class="fw-bold  my-0 lh-base h6" >个人中心 / 我的预约</div>
      <div class="selected-box my-0 lh-base d-flex align-items-center">
        <label for="sele1" class="flex-shrink-0 text-secondary small">筛选：</label>
        <select v-model="params.status" @change="getList(true)" class="form-select form-select-sm  rounded-0 " id="sele1" aria-label="请选择" >
          <option value="">全部</option>
          <option value="0">待审核</option>
          <option value="1">已通过</option>
          <option value="2">已拒绝</option>
          <option value="3">已取消</option>
        </select>
      </div>
    </div>
    <!--没有数据-->
    <NodataCom :show="showNodata"></NodataCom>
    <!--  正在加载-->
    <LoadingCom :show="showLoading"></LoadingCom>
   <div class="d-flex flex-column  flex-sm-row border-bottom px-2 mx-1 py-2" v-for="(item,index) of list" :key="index">
<!--     左边-->
     <div class="flex-shrink-0 d-flex align-items-center justify-content-center image-box rounded-3 shadow-sm bg-light" >
       <img :src="item.MainImage" class="image-width" alt="">
     </div>
<!--     右边-->
     <div class="px-2 flex-fill">
       <div class="d-flex align-items-center justify-content-between mt-1">
         <div class="pub-one-row-flex small text-body-secondary  pub-word-breakAll me-3 flex-1 width-0  ">
           预约设备：<text class="pub-hover-primary point-curser" @click="goDetail(item)">{{item.Device?item.Device.Name?item.Device.Name:"未知":"未知"}}</text>
         </div>
         <span class="badge title-badge badge-blue-green rounded-pill  flex-shrink-0" v-if="item.Status===1">预约成功</span>
         <span class="badge title-badge badge-red-blue rounded-pill  flex-shrink-0" v-if="item.Status===2">预约失败</span>
         <span class="badge title-badge text-bg-warning text-white rounded-pill  flex-shrink-0" v-if="item.Status===3">已取消</span>
       </div>
<!--       时间-->
       <div class="d-flex flex-wrap align-items-center justify-content-end mt-1 py-1">
         <div class="pub-one-row-flex small text-body-secondary  pub-word-breakAll me-3 flex-1 width-0">
           预约时间：{{item.appointTime }}
         </div>
       </div>
       <!--      形式-->
       <div class="d-flex flex-wrap align-items-center justify-content-end mt-1 py-1">
         <div class="pub-one-row-flex small text-body-secondary  pub-word-breakAll me-3 flex-1 width-0">
           预约形式：{{item.ModeName }}
         </div>
       </div>
<!--       地址-->
       <div class="d-flex flex-wrap align-items-center justify-content-end mt-1 ">
         <div class="pub-one-row-flex small text-body-secondary  pub-word-breakAll me-3 flex-1 width-0">
           预约位置：{{item.Device?item.Device.Address?item.Device.Address:"未知":"未知"}}
         </div>
<!--         大屏-->
         <div class="d-flex align-items-center justify-content-end d-sm-block d-none">
           <small class="text-danger-red me-3 small " v-if="item.Status===1">注：预约时间前1天不得取消</small>
           <a class="btn-link text-danger-red me-3 small point-curser" v-if="item.Status===2" @click="showReason(item)">查看原因</a>
           <button type="button" class="btn btn-link text-decoration-none fw-bold btn-sm small-btn-size" @click="quiteAction(item)" v-if="item.Status===1">取消预约</button>
<!--todo-->
           <!--           <button type="button" class="btn btn-link text-danger-red text-decoration-none fw-bold btn-sm small-btn-size" v-else>删除</button>-->
         </div>
       </div>
<!-- h5-->
       <div class="d-flex align-items-center justify-content-end d-block d-sm-none mt-2" >
         <small class="text-danger-red me-3 small " v-if="item.Status===1">注：预约时间前1天不得取消</small>
         <a class="btn-link text-danger-red me-3 small point-curser" v-if="item.Status===2" @click="showReason(item)">查看原因</a>
         <button type="button" class="btn btn-link text-decoration-none fw-bold btn-sm small-btn-size" v-if="item.Status===1">取消预约</button>
<!--         todo-->
<!--         <button type="button" class="btn btn-link text-danger-red text-decoration-none fw-bold btn-sm small-btn-size" v-else>删除</button>-->
       </div>

     </div>

   </div>
  </div>
  <PaginationCom
      @pageChange="pageChangeFun($event)"
      :totalIn="total"
      :currentIn="params.current"
      :pageSizeIn="params.pageSize"
  ></PaginationCom>
  <!--  撤销预约-->
  <div class="modal fade" ref="quitModel" id="quitModel" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title fw-bold" id="exampleModalToggleLabel2">取消预约</div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          确定要取消预约吗?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="callbackState">取消</button>
          <button type="button" class="btn btn-primary" :disabled="callbackState" @click="quite">
            <div class="spinner-border spinner-border-sm" role="status" v-if="callbackState">
              <span class="visually-hidden">Loading...</span>
            </div>
            确定
          </button>
        </div>
      </div>
    </div>
  </div>
<!--  查看原因-->
  <div class="modal fade" ref="appoinitResonModel" id="appoinitResonModel" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered  modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title fw-bold" >拒绝原因</div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body pub-word-breakAll text">
          {{refuseReson || "原因未知"}}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="callbackState">关闭</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import NodataCom from "@/layout/NodataCom"
import LoadingCom from "@/layout/LoadingCom"
import {onMounted, ref, reactive, onBeforeUnmount} from "vue";
import {defaultImage} from "@/utils/commonSetting"

import {Modal} from "bootstrap";
import {myAppointment,cancelAppointment } from "@/api/appoinitment";
import {showToast} from "@/utils/toast";
import {formatDateAndTime, formatTime} from "@/utils/dateFun";
import router from "@/router";
const params = reactive({
  current:1,
  pageSize:10,
  status:""
})
const total  = ref(0)
const list = ref([]) // Status 0 待审核；1 已通过；2 已拒绝; 3 已取消
const showNodata = ref(false)
const showLoading = ref(false)
const callbackState = ref(false);
let quitModelRef = "" // 取消模态框 实例
const quitModel = ref() // 取消模态框 dom
let resonModelRef = "" // 原因模态框 实例
const appoinitResonModel = ref()// 原因模态框 dom
let choisedItem = ""; // 被选中的要操作的
let refuseReson = ref(); // 拒绝的原因
onMounted(()=>{
  // list.value = [
  //   //   0:审核中 1，预约失败 2，已取消
  //   {name:"X射线衍射仪",time:"2024-11-15 9:00~10:00",form:"自主上机",address:"八角湾科创中心一层实验室",statue:0},
  //   {name:"X射线衍射仪",time:"2024-11-15 9:00~10:00",form:"自主上机",address:"八角湾科创中心一层实验室",statue:0},
  //   {name:"X射线衍射仪",time:"2024-11-15 9:00~10:00",form:"自主上机",address:"八角湾科创中心一层实验室",statue:1},
  //   {name:"X射线衍射仪",time:"2024-11-15 9:00~10:00",form:"自主上机",address:"八角湾科创中心一层实验室",statue:2},
  //   {name:"X射线衍射仪",time:"2024-11-15 9:00~10:00",form:"自主上机",address:"八角湾科创中心一层实验室",statue:1},
  //   {name:"X射线衍射仪",time:"2024-11-15 9:00~10:00",form:"自主上机",address:"八角湾科创中心一层实验室",statue:0},
  //   {name:"X射线衍射仪",time:"2024-11-15 9:00~10:00",form:"自主上机",address:"八角湾科创中心一层实验室",statue:2},
  // ]
  getList(true)
})
onBeforeUnmount(()=>{
  hideModel() // 关闭取消按钮
  quitModelRef && quitModelRef.hide();
  resonModelRef && resonModelRef.hide()
})
const showModel = ()=>{
  if(!quitModelRef){
    quitModelRef = new Modal(quitModel.value);
  }
  quitModelRef.show();
}

const hideModel = ()=>{
  if(!quitModelRef){
    // quitModelRef = new Modal(quitModel.value);
    return
  }
  quitModelRef.hide();
}
// 取消预约
const quiteAction =  (item)=>{
  showModel()
  choisedItem = item
  callbackState.value = false
}
const quite = async ()=>{
  callbackState.value = true
  const res = await cancelAppointment({id:choisedItem.ID})
  callbackState.value = false
  if(res.err_code==0){
    // 判断是否要重新请求数据
    const index = list.value.findIndex(item => item.ID === choisedItem.ID);
    if(index > -1){
      list.value[index].Status = 3
    }
    hideModel()
    return showToast("success","取消收藏成功")
  }else{
    return showToast("danger",res.err_msg || "请求出错")
  }
}
const pageChangeFun = (e)=>{
  params.current = e.page
  params.pageSize = e.pageSize
  getList()
}
// 获取消息列表
const getList = async (currentinit)=>{
  if(currentinit){
    params.current = 1
  }
  showLoading.value = true
  showNodata.value = false
  list.value = []
  total.value = 0
  const query = {current:params.current,pageSize:params.pageSize}
  if(params.status!==""){
    query.status = params.status
  }
  const res =await myAppointment(query)
  showLoading.value = false
  if(res.err_code==0){
    const data =  res.data || []
    data.forEach((item,index)=>{
      if(item.CreatedAt){
        item.CreatedAtdeal = formatTime(item.CreatedAt)
      }

      if(!item.Device || !item.Device.MainImage){
        item.MainImage = defaultImage
      }else{
        item.MainImage = item.Device.MainImage
      }
      // 模式
      let StartTime,EndTime,st,et
      if(item.StartTime){
        StartTime = formatDateAndTime(item.StartTime)
        st = StartTime[1]?StartTime[1].slice(0,5):""
      }
      if(item.EndTime){
        EndTime = formatDateAndTime(item.EndTime)
        et = EndTime[1]?EndTime[1].slice(0,5):""
      }
      if(item.Mode==1){
        item.ModeName = "自主上机"
        item.appointTime = StartTime[0] + " " + st + '~' + et
      }else{
        item.ModeName = "送样检测"
        item.appointTime = StartTime[0]
      }
    })
    list.value = data
    total.value = res.total || 0
    if(data.length<=0){
      showNodata.value = true
    }
  }else{
    showToast("danger",res.err_msg || "请求出错")
  }
}
// 展示原因
const showReason = (item)=>{
  refuseReson.value = item.AdminNotes

  if(!resonModelRef){
    resonModelRef = new Modal(appoinitResonModel.value);
  }
  resonModelRef.show()
}
// 查看设备详情,查看设备详情
const goDetail = (item)=>{
  router.push({path:'/equipmentDetail',query:{id:item.Device.ID}})
}

</script>

<style scoped lang="scss">

.title-left{
  word-break: break-all;
}
.title-badge{
  height: 1.5rem;
  line-height: 1rem;
  font-size: 0.7rem;
  font-weight: normal;
  width: 5rem;
}
.small{
  font-size: 0.9rem;
}
.list-box{
  box-sizing: border-box;
}

.small-btn-size{
  height: 1.5rem;
  line-height: 1rem;
}

.btn-check + .btn{
  border: none;
}
.btn-check:checked + .btn{
  color: #0d6efd;
}
//.image-box{
//  width: 100%;
//  background: #f6f7f8;
//  padding: 5px;
//  @media (min-width: 576px){
//    width: 150px;
//  }
//
//}
.image-width{
  width: 300px;
  height: 190px; //100%
  //max-height: 120px;
  object-fit: fill; /* 保持图片比例且填满容器 */
  @media (min-width: 576px){
    width: 150px;
    height: 95px; //100%
  }
}
.selected-box{
  width: 10rem;
  height: 2rem;
}




</style>
